import React from "react";
import logo from '../../assets/logo.svg';
import headerLogo from '../../assets/headerLogo.svg';
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const Logo = ({
  variant = 'default'
}) => {
  switch(variant) {
    case 'header' : 
      return (
        <Link to="/">
          <img src={headerLogo} alt="logo" />
        </Link>
      );
    default :
      return (
        <Link to="/login">
          <img src={logo} alt="logo" />
        </Link>
      );
  }
};

Logo.propTypes = {
  variant: PropTypes.string,
}

export default Logo;
